export const errorNotificationDuration = 5000;